import { createApiClient } from '@aimsos/api-client';
import { tokenService } from '@aimsos/auth';

/**
 * Axios instance for the platform API.
 * Bearer token comes from {@link tokenService} (Auth0 bridge → POST /v1/token exchange).
 */
const rawBase = import.meta.env.VITE_API_BASE_URL || '';
const baseURL = rawBase.replace(/\/+$/, '');

export const { client: api, setToken } = createApiClient({
  baseURL,
  getToken: () => tokenService.getToken(),
  refreshToken: async () => {
    const userUuid = localStorage.getItem('user_uuid') || undefined;
    const tenantUuid = localStorage.getItem('workspace_uuid') || undefined;
    return tokenService.refreshToken(userUuid, tenantUuid);
  },
});
